import Button from "common/components/Button/Button";
import { IconNames } from "components/Icon/Icon";
import { useTranslation } from "react-i18next";

interface IHeaderButtonsEdit {
  onSubmit?: any;
  onCancel?: any;
  isChangingStatus?: boolean;
  extraButtonsComponent?: [
    {
      title?: string;
      type?: string;
      icon?: IconNames;
      loading?: boolean;
      onClick?: () => void;
      disabled?: boolean;
    }
  ];
  onValidate?: () => void;
  validateDisabled?: boolean;
  inHeader?: boolean;
  additionalStyle?: any;
  disabled?: boolean;
}

function HeaderButtonsEdit({
  isChangingStatus,
  extraButtonsComponent,
  onValidate,
  validateDisabled,
  onSubmit,
  onCancel,
  inHeader = false,
  additionalStyle,
  disabled,
}: IHeaderButtonsEdit) {
  const { t } = useTranslation();

  const style = inHeader
    ? `hidden md:flex md:flex-row lg:flex-row md:justify-end flex-wrap gap-2 lg:items-center mt-2 lg:mt-0 ${additionalStyle}`
    : `flex flex-col md:hidden gap-2 white-box mt-4 ${additionalStyle}`;

  return (
    <div className={style}>
      {/* modo actions */}
      {onValidate && !validateDisabled && (
        <Button
          title={t("actions.validate")}
          type="valid-line"
          icon="CheckIcon"
          onClick={onValidate}
          loading={isChangingStatus}
        />
      )}
      {extraButtonsComponent &&
        extraButtonsComponent.map((button) => (
          <Button
            title={button.title}
            type={button.type}
            icon={button.icon}
            onClick={button.onClick}
            loading={button.loading}
            disabled={button.disabled ?? false}
          />
        ))}
      {/* writers actions */}
      {onCancel && (
        <Button
          title={t("actions.cancel")}
          type="secondary"
          icon="XCircleIcon"
          onClick={onCancel}
        />
      )}
      {onSubmit && (
        <Button
          title={t("actions.save")}
          type="primary"
          icon="CheckCircleIcon"
          onClick={onSubmit}
          disabled={disabled ?? false}
        />
      )}
    </div>
  );
}

export default HeaderButtonsEdit;
